export const formatPhone = (value?: string): string => {
  if (!value) {
    return '';
  }

  return value
    .replace(/[\D]/g, '')
    .replace(/(\d{3})(\d)/, '($1) $2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{4})(\d+?)/, '$1');
};

export const formatPhoneOnChangeEvent = (event: {
  target: { value: string };
}): string => {
  return formatPhone(event.target.value);
};
